import { render, staticRenderFns } from "./CustomTypographyInput.vue?vue&type=template&id=69c16df2&"
import script from "./CustomTypographyInput.vue?vue&type=script&lang=ts&"
export * from "./CustomTypographyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports